export default __webpack_public_path__ + "static/media/diameter-blue.d0d5e6d5.svg";